module.exports = __webpack_public_path__ + "img/user-injured-solid.bfbb3a3c.svg";